<template>
  <div class="home">
    <section id="home-first-screen" class="hero first-screen is-fullheight-with-navbar">
      <div class="hero-body is-paddingless">
        <div class="container has-text-centered home-section" style="z-index:1;">
          <div v-scroll-reveal class="spacing-title fadeInUp" >Система</div>
          <h1 v-scroll-reveal class="fadeInUp">
            <span class="name-title" >Авто<span class="has-text-link">реестр</span></span>
          </h1>
          <h2 class="name-subtitle fadeInUp" v-scroll-reveal>
            Автоматизированная система учета<br/>
            предрейсовых осмотров.
          </h2>
          <div class="buttons is-centered">
            <a href="#home-second-screen" class="button is-rounded is-white has-text-grey-dark is-elevated anim-down" @click.prevent="scrollto('#home-second-screen')">
              <i class="fas fa-chevron-down animated infinite slow fadeOutDown"></i>
              <i class="fas fa-chevron-down " style="position:absolute;opacity:.3;"></i>
            </a>
          </div>
          <div class="img-container">
            <div id="home-first-screen-circle" ></div>
          </div>
        </div>
      </div>
    </section>
    <section id="home-second-screen" class="hero is-fullheight-with-navbar">
      <div class="container ">
        <div class="home-section is-flex">
          <div class="home-number" v-scroll-reveal>1.</div>
          <div class="home-section-title" v-scroll-reveal>о сервисе</div>
          <div id="home-second-screen-rect"></div>
        </div>
        <div class="home-section ">
          <div class="columns ">
            <div class="column is-12-mobile is-4-tablet is-6-desktop home-title-container">
              <div class="home-title" v-scroll-reveal="'left'">Ситема учета данных о предрейсовых и послерейсовых тех.осмотрах транспорта и мед.осмотрах водителей.</div>
              <div class="home-subtitle" v-scroll-reveal="'left'">Данные отображаются на карте по геопозиции транспорта.</div>
              <div class="buttons">
                <a href="#home-three-screen" class="button is-rounded is-white has-text-grey-dark is-elevated anim-down" @click.prevent="scrollto('#home-three-screen')">
                  <i class="fas fa-chevron-down animated infinite slow fadeOutDown"></i>
                  <i class="fas fa-chevron-down " style="position:absolute;opacity:.3;"></i>
                </a>
              </div>
            </div>
            <div class="column ">
              <span class="spacing-title" v-scroll-reveal="'right'">для чего сервис</span>
              <div class="home-title" v-scroll-reveal="'right'">Преимущества</div>
              <div class="columns is-mobile is-multiline">
                <div class="column is-6">
                  <div class="columns" v-scroll-reveal="'fade'">
                    <div class="column services-number is-narrow">01</div>
                    <div class="column services-titles">
                      <div class="home-subtitle">Карта</div>
                      <div class="has-text-grey-light">Узнайте, прошел ли водитель медосмотр, испавен ли транспорт - с помощью <router-link to="/map">интерактивной карты</router-link></div>
                    </div>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="columns" v-scroll-reveal="'fade'">
                    <div class="column services-number is-narrow">02</div>
                    <div class="column services-titles">
                      <div class="home-subtitle">Оптими&shy;зация</div>
                      <div class="has-text-grey-light">Инспектор ГИБДД теперь может точечно останавливать транспорт для проверки.</div>
                    </div>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="columns" v-scroll-reveal="'fade'">
                    <div class="column services-number is-narrow">03</div>
                    <div class="column services-titles">
                      <div class="home-subtitle">Цифровизация</div>
                      <div class="has-text-grey-light">Данные о предрейсовых тех.осмотрах транспорта и мед.осмотрах водителей, маршрутные листы теперь в цифровом виде.</div>
                    </div>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="columns" v-scroll-reveal="'fade'">
                    <div class="column services-number is-narrow">04</div>
                    <div class="column services-titles">
                      <div class="home-subtitle">Удобство</div>
                      <div class="has-text-grey-light">Удобная система управления данными для транспортных компаний, станций технического осмотра и мед.работ&shy;ников.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="home-three-screen" class="hero is-fullheight-with-navbar ">
      <div class="hero-body is-paddingless dual-bg " style="align-items:start;">
        <div class="container dual-bg">
          <div class="home-section is-flex has-text-white">
            <div class="home-number" v-scroll-reveal>2.</div>
            <div class="home-section-title" v-scroll-reveal>для кого</div>
            <div id="home-second-screen-rect"></div>
          </div>
        </div>
      </div>
      <div class="hero-body is-paddingless" style="flex-grow: 0;">
        <div class="container ">
          <div class="columns is-gapless is-mobile is-multiline">
            <div class="column is-3-desktop is-6-mobile"><a href="" class="img-link"><img src="~@/assets/img/transport.png" alt="" srcset=""></a></div>
            <div class="column is-3-desktop is-6-mobile"><a href="" class="img-link"><img src="~@/assets/img/teh.png" alt="" srcset=""></a></div>
            <div class="column is-3-desktop is-6-mobile"><a href="" class="img-link"><img src="~@/assets/img/med.png" alt="" srcset=""></a></div>
            <div class="column is-3-desktop is-6-mobile"><a href="" class="img-link"><img src="~@/assets/img/people.png" alt="" srcset=""></a></div>
          </div>
        </div>
      </div>
      <div class="hero-body is-paddingless dual-bg">
        <div class="container">
          <div class="home-section ">
          <div class="columns">
            <div class="column is-4 is-offset-6">
              <div class="home-section is-marginless home-subtitle" v-scroll-reveal="'pulse'">В системе «Автореестр» могут работать руководители транспортных компаний, мед.работники, сотрудники станций техосмотра, инспекторы ГИБДД. Информация доступна для любых заинтересованных лиц.</div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    <section id="home-four-screen" class="hero is-fullheight-with-navbar ">
      <div class="container ">
        <div class="home-section is-flex">
          <div class="home-number has-background-danger has-text-white" v-scroll-reveal>3.</div>
          <div class="home-section-title" v-scroll-reveal>благо&shy;дар&shy;ности</div>
        </div>
        <div class="home-section ">
          <div class="columns ">
            <div class="column is-6 home-title-container">
              <div class="home-title" v-scroll-reveal="'left'">Выражаем благодарность за поддержку в реализации системы.</div>
              <div class="home-subtitle" v-scroll-reveal="'left'">Надеемся, что мы создали полезный сервис для вас!</div>
              <div class="buttons">
                <a href="#home-second-screen" title="контакты" class="button is-rounded is-white has-text-grey-dark is-elevated anim-down" @click.prevent="scrollto('#home-five-screen')">
                  <i class="fas fa-chevron-down animated infinite slow fadeOutDown"></i>
                  <i class="fas fa-chevron-down " style="position:absolute;opacity:.3;"></i>
                </a>
              </div>
            </div>
            <div class="column ">
              <div v-scroll-reveal>
                <div class="home-title is-marginless">Фонд содействия инновациям</div>
                <div class="home-subtitle has-text-grey-light">Система разработана при поддержке фонда</div>
              </div>
              <div v-scroll-reveal>
                <div class="home-title is-marginless">Цифровой прорыв</div>
                <div class="home-subtitle has-text-grey-light">Первые идеи придуманы на хакатоне ЦП</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="home-five-screen" class="hero is-fullheight-with-navbar ">
      <div class="hero-body is-paddingless dual-bg-2" style="align-items:start;">
        <div class="container ">
          <div class="home-section is-flex" v-scroll-reveal>
            <div class="home-number " >4.</div>
            <div class="home-section-title">кон&shy;так&shy;ты</div>
          </div>
          <div class="home-section ">
            <div class="columns ">
              <div class="column is-6 home-title-container">
                <div class="home-title" v-scroll-reveal="'left'">Ждем ваших предложений.</div>
                <div class="home-subtitle" v-scroll-reveal="'left'">Мы всегда открыты для сотрудничества</div>
                <div class="buttons">
                  <a href="#home-second-screen" title="наверх" class="button is-rounded is-white has-text-grey-dark is-elevated anim-down" @click.prevent="scrollto('#home-first-screen')">
                    <i class="fas fa-chevron-up animated infinite slow fadeOutUp"></i>
                    <i class="fas fa-chevron-up " style="position:absolute;opacity:.3;"></i>
                  </a>
                </div>
              </div>
              <div class="column " >
                <div class=" has-background-light home-section" >
                  <div v-scroll-reveal>
                    <span class="spacing-title">Ваши предложения</span>
                    <div class="home-title">Свяжитесь с нами</div>
                  </div>
                  <div class="columns is-vcentered is-mobile" v-scroll-reveal="'pulse'">
                    <div class="column services-number is-narrow">
                      <i class="fas fa-phone has-text-grey-light"></i>
                    </div>
                    <div class="column services-titles">
                      <div class="home-title is-marginless">8-951-93-88-917</div>
                      <div class="home-subtitle is-marginless has-text-grey-light">Руководитель</div>
                    </div>
                  </div>
                  <div class="columns is-vcentered is-mobile" v-scroll-reveal="'pulse'">
                    <div class="column services-number is-narrow">
                      <i class="fas fa-envelope has-text-grey-light"></i>
                    </div>
                    <div class="column services-titles">
                      <div class="home-title is-marginless">vasilyman&shy;@mail.ru</div>
                      <div class="home-subtitle is-marginless has-text-grey-light">Почта</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>ОСМОТР</strong> by <a href="https://remonstro.ru">Remonstro</a>. Охраняется патентом
        </p>
      </div>
    </footer> -->
  </div>
</template>

<script>
export default {
  // metaInfo () {
  //   return {
  //     title: this.$_.upperFirst(this.$tc(this.$route.meta.title))
  //   }
  // },
  methods: {
    scrollto (anchor) {
      const topBar = document.querySelector('.navbar.is-fixed-top')
      const offset = topBar ? topBar.offsetHeight : 0
      const top = document.querySelector(anchor).offsetTop - offset
      window.scrollTo({
        top,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="scss">
  .section-left {
    padding: 0 1.5rem 3rem 1.5rem;

    @include mobile {
      padding-top: 3rem;
    }
  }
  .img-link {
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .dual-bg-2 {
    background-image: linear-gradient(90deg, $warning 0, $warning 50%, $light 50%, $light 100%);
  }
  .dual-bg {
    background-image: linear-gradient(90deg, $link 0, $link 50%, $info 50%, $info 100%);
  }
  .services-number {
    font-size: 2.25rem;
    font-weight: bold;
    line-height: .75;
  }
  .home-title-container {
    padding-right: 15%;

    @include touch {
      padding-right: .75rem;
    }
  }
  .home-title {
    font-size: 1.5rem;
    line-height: 1.25;
    margin-bottom: 1.5rem;
    font-weight: bold;
  }
  .home-subtitle {
    font-size: 1.12rem;
    margin-bottom: 1.12rem;
  }
  #home-second-screen-rect {
    background-color: $warning;
    height: 240px;
    width: 200px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    @include touch {
      left: 1rem;
    }

    @include mobile {
      height: 120px;
      width: 100px;
    }
    @include tablet {
      height: 170px;
      width: 150px;
    }
    @include desktop {
      height: 240px;
      width: 200px;
    }
  }
  .home-section {
    // display: flex;
    padding: 3rem 1rem 3rem 1rem;
    // z-index: 1;
    @include mobile {
      padding: 1.5rem 1rem 1rem 1rem;
    }
    @include tablet {
      padding: 2rem 1rem 2rem 1rem;
    }
    @include desktop {
      padding: 3rem 1rem 3rem 1rem;
    }
  }
  .home-number {
    padding: 1rem;
    font-size: 10rem;
    line-height: 1;
    font-weight: 900;
    margin-right: 2.5rem;

    @include mobile {
      margin-right: 1rem;
      font-size: 5rem;
    }
    @include tablet {
      margin-right: 1.5rem;
      font-size: 7rem;
    }
    @include desktop {
      font-size: 10rem;
    }
  }
  .home-section-title {
    width: auto;
    // word-break: break-word;
    padding-top: 1rem;
    font-size: 4.5rem;
    line-height: 1;
    font-weight: 900;

    @include mobile {
      font-size: 2.2rem;
    }
    @include tablet {
      font-size: 3.5rem;
    }
    @include desktop {
      font-size: 4.5rem;
    }
  }
  .first-screen {
    background-image:
      linear-gradient(-45deg, rgba(0, 0, 0, 0.3) 0%, rgba(255, 255, 255, 0.3) 70%, rgba(255, 255, 255, 0.3) 100%),
      linear-gradient(rgba(white, .95), rgba(white, .95)),
      url(~@/assets/img/first-screen.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-blend-mode:hard-light;
  }
  .spacing-title {
    letter-spacing: .26rem;
    font-size: .75rem;
    display: block;
    text-transform: uppercase;
    color: $grey-light;
  }
  .name-title {
    font-size: 4.5rem;
    font-weight: 900;
    text-transform: uppercase;
    color: $grey-light;

    @include mobile {
      font-size: 2.2rem;
    }
    @include tablet {
      font-size: 3.5rem;
    }
    @include desktop {
      font-size: 4.5rem;
    }
  }
  .name-subtitle {
    font-size: 1.12rem;
    font-weight: bold;
    padding-bottom: 1rem;
  }
  .img-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }
  #home-first-screen-circle {
    position: absolute;
    background-color: #fee74c;
    border-radius: 5rem;
    width: 10rem;
    height: 10rem;
    top: 50%;
    left: 50%;
    transform: translate(100%, -40%);

    @include mobile {
      width: 5rem;
      height: 5rem;
      border-radius: 3rem;
      transform: translate(90%, -90%);
    }
    @include tablet {
      width: 7rem;
      height: 7rem;
      border-radius: 3.5rem;
      transform: translate(100%, -50%);
    }
    @include desktop {
      width: 10rem;
      height: 10rem;
      border-radius: 5rem;
      transform: translate(100%, -40%);
    }
  }
</style>
